import { takeLatest, call, put } from 'redux-saga/effects';
import { saveAs } from 'file-saver';
import URLS from '../constants/urls';
import { callApi } from '../utils/api';
import * as BillAction from '../actions/billAction';
import * as SnackbarAction from '../actions/snackbarAction';

function* currentBalance(action) {
  try {
    const response = yield call(
      callApi,
      URLS.BILL_BALANCE,
      'GET',
      action.payload,
    );
    const data = {
      previousBalance: response.res_data.bills || [],
      billTableCount: response.res_data?.count || 0,
      payments: [],
    };
    yield put(BillAction.setPreviousBalance(data));
  } catch (error) {
    // console.log(error, 14);
    const data = {
      previousBalance: [],
      billTableCount: 0,
      payments: [],
    };
    yield put(BillAction.setPreviousBalance(data));
  }
}

function* billDetails(action) {
  try {
    const response = yield call(
      callApi,
      URLS.BILL_DETAILS,
      'GET',
      action.payload,
    );
    yield put(BillAction.setBillDetails(response.res_data));
  } catch (error) {
    // console.log(error, 14);
    yield put(BillAction.setBillDetails({}));
  }
}

function* billTransactions(action) {
  try {
    const response = yield call(
      callApi,
      URLS.BILL_TRANSACTIONS,
      'GET',
      action.payload,
    );
    yield put(BillAction.setBillTransactions(response.res_data));
  } catch (error) {
    // console.log(error, 14);
    yield put(BillAction.setBillTransactions({}));
  }
}

function* billPenalties(action) {
  try {
    const response = yield call(
      callApi,
      URLS.BILL_PENALTIES,
      'GET',
      action.payload,
    );
    yield put(BillAction.setBillPenalties(response.res_data));
  } catch (error) {
    yield put(BillAction.setBillPenalties({}));
  }
}

function* paymentList(action) {
  try {
    const response = yield call(callApi, URLS.SEARCH, 'GET', action.payload);
    const data = {
      previousBalance: [],
      billTableCount: response.res_data?.count || 0,
      payments: response.res_data.result || [],
    };
    yield put(BillAction.setPreviousBalance(data));
  } catch (error) {
    // console.log(error);
    const data = {
      previousBalance: [],
      billTableCount: 0,
      payments: [],
    };
    yield put(BillAction.setPreviousBalance(data));
  }
}

function* getCurrentBalance(action) {
  try {
    const response = yield call(
      callApi,
      URLS.GET_CURRENCT_BALANCE,
      'GET',
      action.payload,
    );
    if (Object.keys(response.res_data).length === 0) {
      response.res_data = { error: true };
    }
    yield put(BillAction.setCurrentBalance(response.res_data));
  } catch (error) {
    // console.log(error);
    yield put(BillAction.setCurrentBalance({ error: true }));
  }
}
function* resetBillDetails(action) {
  try {
    yield put(BillAction.setCurrentBalance({}));
  } catch (error) {
    // console.log(error);
  }
}

function* getVirtualAcc(action) {
  try {
    const response = yield call(
      callApi,
      URLS.VIRTUAL_ACC_DETAILS,
      'GET',
      action.payload,
    );
    yield put(BillAction.setAccountDetails(response.res_data));
  } catch (error) {
    // console.log(error);
  }
}

function* downloadPdfXlsCsv(action) {
  try {
    const response = yield call(
      callApi,
      URLS.BILL_PDF_XLS_CSV,
      'GET',
      action.payload,
      false,
      null,
      true,
    );
    try {
      const { type } = action.payload;
      const id = action.payload.bill_id;
      let fileName = `${id}.pdf`;
      // let FileType = 'application/pdf'
      if (type === 'csv') {
        fileName = `${id}.csv`;
        // FileType = 'text/csv'
      } else if (type === 'excel') {
        fileName = `${id}.xls`;
        // FileType = 'application/ms-excel'
      }
      // const blob = new Blob([response],{type:FileType})
      const blob = new Blob([response]);
      // const objectUrl = window.URL.createObjectURL(blob);
      // window.open(objectUrl)
      saveAs(blob, fileName);
      yield put(
        SnackbarAction.openSnackbar({
          message: 'File generated successfully',
          type: 'success',
        }),
      );
    } catch (err) {
      yield put(
        SnackbarAction.openSnackbar({
          message: 'Something went wrong! Please try again later.',
          type: 'error',
        }),
      );
    }
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* BalanceSaga() {
  yield takeLatest('PREV_BALANCE', currentBalance);
  yield takeLatest('GET_BILL_DETAIL', billDetails);
  yield takeLatest('GET_BILL_TRANSACTION', billTransactions);
  yield takeLatest('GET_BILL_PENALTIES', billPenalties);
  yield takeLatest('PAYMENT_LIST', paymentList);
  yield takeLatest('GET_CURRENT_BALANCE', getCurrentBalance);
  yield takeLatest('RESET_BILL_DETAILS', resetBillDetails);
  yield takeLatest('VIRTUAL_ACC_DETAIL', getVirtualAcc);
  yield takeLatest('PDF-CSV-XLS', downloadPdfXlsCsv);
}
